module.exports = __webpack_public_path__ + "static/media/Template_15.f03129b2.png";